import type { DefaultDashboardDefinition } from './dashboard-definition';

export const bankAccountDashboard: DefaultDashboardDefinition = {
  id: "finance.bank-account",
  appId: "finance",
  name: "Bank Account dashboard",
  record: {
    separator: ".",
    suffix: "main",
    placementIds: "record",
    placementSeparator: "-",
  },
  queryScope: null,
  placements: [
    {
      id: "bank-position",
      widgetId: "finance.bank-account-position",
      placement: {
        x: 0,
        y: 0,
        width: 12,
        height: 6,
      },
      bindContext: true,
    },
    {
      id: "bank-movements",
      widgetId: "finance.bank-account-movement",
      placement: {
        x: 0,
        y: 6,
        width: 12,
        height: 6,
      },
      bindContext: true,
    },
  ],
};
